import { render, staticRenderFns } from "./vrMGT.vue?vue&type=template&id=785bc4fb&scoped=true&"
import script from "./vrMGT.vue?vue&type=script&lang=js&"
export * from "./vrMGT.vue?vue&type=script&lang=js&"
import style0 from "./vrMGT.vue?vue&type=style&index=0&id=785bc4fb&lang=stylus&scoped=true&"
import style1 from "./vrMGT.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785bc4fb",
  null
  
)

component.options.__file = "vrMGT.vue"
export default component.exports